import { render, staticRenderFns } from "./Stalci.vue?vue&type=template&id=fbc21f04&scoped=true&"
import script from "./Stalci.vue?vue&type=script&lang=ts&"
export * from "./Stalci.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc21f04",
  null
  
)

export default component.exports